import { useSSFBehaviors, useURLParameters } from 'hooks';
import { FC, useContext, useMemo } from 'react';
import {
  OrderStatusEnum,
  PositionTypeEnum,
  SettingsPageFetchPositionByIdQuery,
} from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';
import { useLocation } from 'react-router-dom';
import { SSFBehaviorsContextType } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { requestPositionJanesConfig } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/RemovePosition.constants';
import { ChangeFunctionType } from '@bookjane2/bookjane-design-library/lib/common.types';

export const RemovePositionDataContext = createGQLDataContext<
  SSFBehaviorsContextType<SettingsPageFetchPositionByIdQuery>
>({} as SSFBehaviorsContextType<SettingsPageFetchPositionByIdQuery>);

export const RemovePositionDataProvider: FC = ({ children }) => {
  const [{ positionId }] = useURLParameters<{ positionId: string }>();
  const { pathname } = useLocation();
  const facility_id = Number.parseInt(pathname.split('/')[3]);

  const [values, rest] = useSSFBehaviors(
    requestPositionJanesConfig({
      positionId: Number(positionId),
      facilityId: facility_id,
      positionType: PositionTypeEnum.primary,
      teamMemberFilter: {
        byPrimaryCommunity: [facility_id],
      },
      orderFilter: {
        forOrders: {
          withStatus: [OrderStatusEnum.pending],
          withCommunity: [facility_id],
        },
      },
    }),
  );

  const contextValue = useMemo(() => ({ values, ...rest }), [rest, values]);

  return (
    <RemovePositionDataContext.Provider value={contextValue}>
      {children}
    </RemovePositionDataContext.Provider>
  );
};

export const useRemovePositionDataContext =
  (): SSFBehaviorsContextType<SettingsPageFetchPositionByIdQuery> & {
    handleChange: ChangeFunctionType;
    data: SettingsPageFetchPositionByIdQuery;
  } => useContext(RemovePositionDataContext);
